import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
import { store } from "../Redux/store";
import i18next from "i18next";

const { login } = store.getState();

// const user_id = login.user;
// const store_id = login.user;

// Assuming URLS is correctly imported and contains the SEARCH_ORDER URL

export const GetPaymentMethods = async ({user_id}) => {
  console.log("id===>",user_id);
  
  try {
    const response = await axiosInstance.post(URLS.GET_ALL_METHODS, {user_id: user_id});

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const GetSelectedMethods = async ({user_id}) => {
  try {
    const response = await axiosInstance.post(URLS.GET_SELECTED_METHODS, {user_id: user_id});

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updatePaymentModes = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_METHODS, payload);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const GetOrderFrom = async ({user_id}) => {
  try {
    const response = await axiosInstance.post(URLS.ORDER_FROM, {user_id: user_id});

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updateOrderFrom = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_ORDER_FROM, payload);

    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updateUserRights = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_USER_RIGHTS, payload);

    return response?.data;
  } catch (error) {
    return error;
  }
};